import {defineStore} from "pinia";

export const settingStore = defineStore('setting', {
    state: () => {
        return {
            sidebar: true,
            device: 'desktop',
            theme: 'dark',
            sidebarOpened: true,
            layout: 'sidemenu',
            multiTab: true,
            fixedHeader: false,
            fixSiderbar: false,
        }
    }
})